import getBaseModalStyles from './getBaseModalStyles';

export default getBaseModalStyles;
